<ion-header class="messageHeader">
  <ion-toolbar mode="ios" color="transparent" class="messageHeader__toolbar">
    <ion-buttons slot="end">
      <ion-button (click)="dismissModal()">
        <ion-icon slot="icon-only" name="close" />
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
  <div class="messageHeader__mediaBox">
    @for (media of message().media; track $index) {
      @if (media.type === MediaType.ICON) {
        <ion-icon slot="icon-only" class="messageHeader__icon" [src]="media.url" />
      }

      @if (media.type === MediaType.ANIMATION && animationConfig(); as animationConfig) {
        <app-animation class="messageHeader__animation" [animation]="animationConfig" />
      }
    }

    <div class="messageHeader__confettiBox" #confetti></div>
  </div>
</ion-header>

<div class="messageContent">
  <div class="messageContent__padding">
    <div [innerHTML]="markdownService.parse(message().msg) | safe"></div>
  </div>
</div>

<ion-footer class="messageFooter">
  @if (!message().buttons?.length) {
    <ion-button expand="block" shape="round" (click)="dismissModal()">
      <ion-label>{{ 'txt-understand' | tr }}</ion-label>
    </ion-button>
  } @else {
    @for (button of message().buttons; track $index) {
      @if (button.url) {
        <a
          [href]="button.url"
          class="messageFooter__cta"
          [attr.uid]="'confettiMessageModal__ctaBtn__' + message().msgKey"
        >
          {{ button.label }}
        </a>
      } @else {
        <ion-button expand="block" shape="round" (click)="dismissModal()">
          <ion-label>{{ button.label | tmd | stripTags }}</ion-label>
        </ion-button>
      }
    }
  }
</ion-footer>
